import { useCallback, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { Socket } from 'socket.io-client';
import { ORDER_GET_ONE } from 'api/query-keys';
import type { IOrderInvalidateManyEvent } from './types';
import { ESocketEventName } from './types';

export const useHandleOrderInvalidateMany = (socket: Socket) => {
  const queryClient = useQueryClient();

  const handler = useCallback(
    async (event: IOrderInvalidateManyEvent) => {
      const orderIds = event.payload.orderIds;

      await Promise.all(orderIds.map((orderId) => queryClient.invalidateQueries([ORDER_GET_ONE, orderId])));
    },
    [queryClient],
  );

  useEffect(() => {
    socket.on(ESocketEventName.orderInvalidateMany, handler);

    return () => {
      socket.removeListener(ESocketEventName.orderInvalidateMany, handler);
    };
  }, [handler, socket]);
};
